import React from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'green' | 'blue' | 'red';
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'md',
  color = 'primary'
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-4 w-7';
      case 'lg':
        return 'h-7 w-12';
      default:
        return 'h-5 w-9';
    }
  };

  const getToggleClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-3 w-3';
      case 'lg':
        return 'h-6 w-6';
      default:
        return 'h-4 w-4';
    }
  };

  const getColorClasses = () => {
    if (disabled) return 'bg-gray-200';
    
    switch (color) {
      case 'green':
        return checked ? 'bg-green-500' : 'bg-gray-200';
      case 'blue':
        return checked ? 'bg-blue-500' : 'bg-gray-200';
      case 'red':
        return checked ? 'bg-red-500' : 'bg-gray-200';
      default:
        return checked ? 'bg-primary-500' : 'bg-gray-200';
    }
  };

  const getTranslateClasses = () => {
    switch (size) {
      case 'sm':
        return checked ? 'translate-x-3' : 'translate-x-0';
      case 'lg':
        return checked ? 'translate-x-5' : 'translate-x-0';
      default:
        return checked ? 'translate-x-4' : 'translate-x-0';
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`
        relative inline-flex items-center rounded-full border-2 border-transparent 
        transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        ${getSizeClasses()}
        ${getColorClasses()}
        ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
      `}
    >
      <span
        aria-hidden="true"
        className={`
          pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition duration-200 ease-in-out
          ${getToggleClasses()}
          ${getTranslateClasses()}
        `}
      />
    </button>
  );
}; 